import React from 'react'
import * as routes from './routes'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { isDevAuthBypassEnabled } from './authConfig'

const mapStateToProps = state => ({
    access_token: state.access_token,
    username: state.username,
})

const onlyLoggedIn = Component =>
    connect(mapStateToProps)(
        props => (isDevAuthBypassEnabled() || props.access_token)
            ? <Component {...props} />
            : <Redirect to={routes.HOME} />
    )



export default onlyLoggedIn